import { z } from "zod";

const errorMessages = {
  required: "وارد کردن این فیلد اجباری است",
};

const schema = z
  .object({
    role: z.string().min(1, errorMessages.required),
    faculties: z.string().nullable().optional(),
    fields: z.string().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.role && !["general_admin", "superuser"].includes(data.role) && !data.faculties) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: errorMessages.required,
        path: ["faculties"],
      });
    }
  });

export { schema };
